import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { cardTypes } from "../../resources/keys.resources";
import * as CryptoJS from 'crypto-js';
import {
  keysUniversal
} from '../../resources/keys.resources';
import { StoreServiceLibrary } from '../store/store.service';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SecurityModel } from "src/app/models/security.model";
declare var window: any;
declare var lpTag: any;
declare var cordova: any;



@Injectable({
  providedIn: "root",
})
export class GeneralUtilService {

  dateUser;

  security: SecurityModel = {
    ip: '',
    host: '',
    cookie: '',
    userAgent: '',
    deviceFingerPrint: ''
  };

  constructor(private store: StoreServiceLibrary,
    private _http: HttpClient) { }

  setSecurityObject(security?: SecurityModel) {
    this.security['ip'] = security.ip;
    this.security['host'] = security.host;
    this.security['cookie'] = security.cookie;
    this.security['userAgent'] = security.userAgent;
    this.security['deviceFingerPrint'] = security.deviceFingerPrint;
  }

  getSecurityObject(): SecurityModel {
    return this.security;
  }

  getLocalDate() {
    return this.dateUser;
  }

  setLocalDate(date) {
    this.dateUser = date;
  }
}
